








































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faCameraRetro } from '@fortawesome/free-solid-svg-icons';

// Components
import BasicSelect from '@/components/common/BasicSelect.vue';
import BaseInput from '@/components/common/BaseInput.vue';
import BaseTextarea from '@/components/common/BaseTextarea.vue';
import QuestionListItemGroup from '@/views/question/components/QuestionListItem/QuestionListItemGroup.vue';
import QuestionListItemOptions from '@/views/question/components/QuestionListItem/QuestionListItemOptions.vue';
import QuestionListItemAction from '@/views/question/components/QuestionListItem/QuestionListItemAction.vue';
import SubQuestionSection from '@/views/question/components/SubQuestionSection.vue';
// Constants
import {
  QUESTION_TYPE_OPTIONS,
  QUESTION_TYPES,
  QUESTION_SCORE_OPTIONS,
} from '@/views/question/constants';
// Icons
import iconTrash from '@/assets/img/icon-trash.svg';
import iconAddCircleSmall from '@/assets/img/icon-add-circle-small.svg';

@Component({
  components: {
    BasicSelect,
    BaseInput,
    BaseTextarea,
    QuestionListItemGroup,
    QuestionListItemOptions,
    QuestionListItemAction,
    SubQuestionSection,
  },
})
export default class QuestionListItem extends Vue {
  @Prop(Object) question: any;
  @Prop([String, Number]) questionOptionEditting: string | number;
  @Prop(Boolean) readOnly: boolean;
  @Prop(Boolean) hiddenIconDrag: boolean;
  @Prop(Boolean) hiddenIconDelete: boolean;
  @Prop(Number) questionIndex: number;
  @Prop({ default: () => [] }) allQuestions!: any[];

  isSubmiting = false;
  isLoading: boolean = false;
  isEditQuestion: boolean = false;

  get refSubQuestionSection() {
    return this.$refs.subQuestionSection as any;
  }

  get iconTrash() {
    return iconTrash;
  }

  get iconAddCircleSmall() {
    return iconAddCircleSmall;
  }

  get typeOptions() {
    return QUESTION_TYPE_OPTIONS;
  }

  get scoreOptions() {
    return QUESTION_SCORE_OPTIONS;
  }

  get isShowInputPlaceholder() {
    const { INPUT, TEXTAREA } = QUESTION_TYPES;
    return [INPUT, TEXTAREA].includes(this.question.type);
  }

  get isShowQuestionOptions() {
    const { CHECKBOX, RADIO } = QUESTION_TYPES;
    return [CHECKBOX, RADIO, 'pulldown'].includes(this.question.type);
  }

  get questionErrorMessages() {
    return {
      max: '質問は255文字以内で入力してください',
    };
  }

  get questionInputErrorMessages() {
    return {
      max: '質問は100文字以内で入力してください',
      numeric: '正の整数を入力してください',
    };
  }

  get isTextArea() {
    return this.question.type === QUESTION_TYPES.TEXTAREA;
  }

  get subQuestionLabel() {
    const config = this.question.sub_question_config;
    const count = config?.sub_question_ids?.length || 0;
    return count > 0 ? `${count} 件のサブ質問を選択中` : '';
  }

  questionValue(value) {
    if (!value || typeof value !== 'string') {
      return '';
    }
    let result = '';
    const stringCutLine = value.split('\\n');
    let stringCutWrongCharacter: any = [];

    stringCutLine
      .filter((data) => data)
      .map((data) => {
        stringCutWrongCharacter = [
          ...stringCutWrongCharacter,
          data.replace(/\\/g, ''),
        ];
        return data;
      })
      .map((data, index) => {
        if (index === 0) {
          result = result + data;
        } else {
          result = result + '\n' + data;
        }
      });

    return result;
  }

  async created() {
    library.add(faCameraRetro);
    dom.watch();
  }

  handleAddSubQuestion(answer: string) {
    if (this.refSubQuestionSection) {
      this.refSubQuestionSection.openSelectModal(answer);
    }
  }
}
